import { lighten } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    marginTop: 30,
  },
  main: {
    minHeight: 500,
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0eb',
  },
  table: {
    minWidth: 750,
    '& tr th:nth-of-type(-n+1)': {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
    '& tr td:nth-of-type(-n+1)': {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
      color: '#7e7d7e',
    },
  },
  searchBtn: {
    marginRight: 20,
  },
  deleteIcon: {
    cursor: 'pointer',
    '&:hover': {
      color: 'red',
    },
    '&:active': {
      color: 'OrangeRed',
    },
  },
  searchInput: {
    flexGrow: 2,
    marginLeft: 20,
    '&>.MuiInputBase-root': {
      fontSize: 14,
      '&>.MuiOutlinedInput-input': {
        paddingTop: '12px',
        paddingBottom: '12px',
      },
    },
  },
}));

export default useStyles;
